module.exports = __webpack_public_path__ + "static/media/modal-indonesia-signup.78cf6353.svg";